(() => {
  const { twigWorker } = window.swinger.webworker;
  const timers = window.WeakMap ? new WeakMap() : new Map();
  const alreadyTriggeredSnackbars = new Set();
  const suppressDurationMinutes = 60;
  const processClose = (elem) => {
    const id = elem.getAttribute('id');
    const toggleElems = window.swinger.$(`[aria-controls="${id}"]`);

    window.swinger.visibility.hide(elem);

    toggleElems.forEach((elem) => {
      elem.setAttribute('aria-expanded', 'false');
    });

    if (elem.close) {
      elem.close();
    }

    elem.parentNode.removeChild(elem);
  };
  const close = (elem) => {
    if (!elem) {
      return false;
    }

    alreadyTriggeredSnackbars.delete(elem.getAttribute('data-hash'));

    if (elem.hasAttribute('data-suppressible')) {
      const suppressedSnackbars = window.swinger.storage.get('swinger.snackbar.suppressed') || {};
      suppressedSnackbars[elem.getAttribute('data-hash')] = (new Date()).getTime();

      window.swinger.storage.set('swinger.snackbar.suppressed', suppressedSnackbars);
    }

    elem.classList.add('swinger-snackbar--is-closing');
    window.setTimeout(() => {
      processClose(elem);
    }, 300);

    return true;
  };
  let timer;
  const addToContainer = (elem, sound = 'notify') => {
    window.clearTimeout(timer);
    timer = window.setTimeout(() => {
      const containerId = 'swinger-snackbar-container';
      const container = document.getElementById(containerId);

      if (!container) {
        window.setTimeout(() => {
          addToContainer(elem, sound);
        }, 300);
        return;
      }

      container.appendChild(elem);
      window.swinger.audioHapticFeedback.trigger(sound);
    });
  };
  const create = (data) => {
    if (!data.children || !data.children.length) {
      return;
    }

    const suppressedSnackbars = window.swinger.storage.get('swinger.snackbar.suppressed') || {};
    const hash = JSON.stringify(data.children);

    if (alreadyTriggeredSnackbars.has(hash)) {
      return;
    }

    alreadyTriggeredSnackbars.add(hash);

    if (
      data.isSuppressible
      && suppressedSnackbars[hash]
    ) {
      const lastSupressedTimestamp = suppressedSnackbars[hash];

      if ((lastSupressedTimestamp + (suppressDurationMinutes * 60 * 1000)) > (new Date()).getTime()) {
        return;
      }
    }

    if (data.id && document.getElementById(`swinger-snackbar-${data.id}`)) {
      const elem = document.getElementById(`swinger-snackbar-${data.id}`);
      window.clearTimeout(timers.get(elem));
      close(elem);
    }

    twigWorker.postMessage({
      action: 'render',
      id: 'snackbar',
      component: 'snackbar',
      data,
    });
  };

  // Let a few seconds pass when the page just loads
  // until we boot up the self-closing timers
  // for orientation purposes
  window.setTimeout(() => {
    window.swinger.observer.initialize('.swinger-snackbar--is-selfclosing', (elem) => {
      timers.set(elem, window.setTimeout(() => {
        close(elem);
      }, 5000));
    });
  }, 5000);

  window.swinger.eventHub.register('click', '.swinger-snackbar [data-close]', (e) => {
    const elem = e.target.closest('.swinger-snackbar');

    window.clearTimeout(timers.get(elem));
    close(elem);

    e.preventDefault();
    e.stopImmediatePropagation();
  });

  twigWorker.addEventListener('message', (e) => {
    const { type } = e.data;

    if (type !== 'snackbar') {
      return;
    }

    const html = e.data.html.trim();
    const helperElem = document.createElement('div');

    helperElem.innerHTML = html;

    addToContainer(helperElem.firstElementChild, html.indexOf('error') > -1 ? 'none' : 'notify');
  });

  window.swinger = window.swinger || {};
  window.swinger.snackbar = {
    create,
    alreadyTriggeredSnackbars,
  };

  window.swinger.observer.initialize('.swinger-snackbar[data-uniquekey][data-type="info"],.swinger-snackbar[data-uniquekey][data-type="success"]', (elem) => {
    const uniqueKey = elem.getAttribute('data-uniqueKey');
    const apiBase = window.swinger.config.apiBase;

    window.requestAnimationFrame(() => {
      if (
        !window.swinger.config.apiRoutes.notifications
        || !window.document.visibilityState
        || window.document.visibilityState !== 'visible'
      ) {
        return;
      }

      window.swinger
        .ajax(`${apiBase}${window.swinger.config.apiRoutes.notifications}`, {
          method: 'DELETE',
          body: JSON.stringify({
            uniqueKey,
          }, null, 4),
        })
        .then(() => {
          console.log(`Successfully marked notification with uniqueKey ${uniqueKey} as read`);
        })
        .catch((e) => {
          console.log(`An error occurred while trying to mark notification with uniqueKey ${uniqueKey} as read:`, e);
        });
    });
  });
})();
